import React from "react";
import { PDFViewer } from "@react-pdf/renderer";
import { Resume } from "./Resume";

export const Renderer = ({ resume }) => (
  <PDFViewer>
    <Resume content={resume} />
  </PDFViewer>
);
